import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ControlContainer,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { ServiceDataFields } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/service-data-fields.enum';
import { CancerHistoryStatus } from '@app/modules/service-data/types/service-data.types';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationErrorComponent } from '@shared/components/validation-error/validation-error.component';
import { controlContainerProvider } from '@shared/helpers';
import { startWith, Subject } from 'rxjs';

@Component({
  selector: 'app-service-data-form-cancer-history',
  imports: [
    ValidationErrorComponent,
    TranslateModule,
    ReactiveFormsModule,
    AsyncPipe,
  ],
  templateUrl: './service-data-form-cancer-history.component.html',
  styleUrls: ['./service-data-form-cancer-history.component.scss'],
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDataFormCancerHistoryComponent implements OnInit {
  private controlContainer = inject(ControlContainer);

  @Input({ required: true }) fieldSet: string[];
  protected get form() {
    return this.controlContainer.control as FormGroup;
  }

  protected cancerHistoryStatus = CancerHistoryStatus;
  protected isCancerRecovered$ = new Subject<boolean>();

  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.form
      .get('cancerHistory.status')
      .valueChanges.pipe(
        startWith(this.form.get('cancerHistory.status').value),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((cancerHistoryStatus: CancerHistoryStatus) =>
        this.isCancerRecovered$.next(
          cancerHistoryStatus === CancerHistoryStatus.Recovered
        )
      );

    this.form
      .get('cancerHistory.hasHistory')
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: boolean) => {
        if (!value) {
          this.form.get('cancerHistory.status').reset(null);
        }
      });
  }

  protected readonly ServiceDataFields = ServiceDataFields;
}
